import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { GlowOrb } from '../components/GlowOrb';
import { Moon, Mail, Lock } from 'lucide-react';
export function Login() {
  return <div className="min-h-screen flex items-center justify-center relative overflow-hidden py-24" data-id="element-730">
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
      backgroundImage: `url(https://images.unsplash.com/photo-1534447677768-be436bb09401?q=80&w=2000&auto=format&fit=crop)`
    }} data-id="element-731"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-midnight/70 to-midnight" data-id="element-732"></div>
      <GlowOrb color="gold" size="lg" position="-top-20 -right-20" data-id="element-733" />
      <GlowOrb color="primary" size="xl" position="-bottom-40 -left-40" data-id="element-734" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-735">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-md mx-auto glass p-8 md:p-12 rounded-3xl" data-id="element-736">
          <div className="text-center mb-10" data-id="element-737">
            <Moon className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-738" />
            <h1 className="text-3xl font-serif text-white mb-2" data-id="element-739">
              Welcome Back
            </h1>
            <p className="text-beige-muted text-sm" data-id="element-740">
              Enter your sacred space to manage your healing journey.
            </p>
          </div>

          <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-741">
            <div className="space-y-2" data-id="element-742">
              <label className="text-sm font-medium text-beige" data-id="element-743">
                Email Address
              </label>
              <div className="relative" data-id="element-744">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" data-id="element-745" />
                <input type="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white placeholder:text-white/20 transition-all" placeholder="your@email.com" data-id="element-746" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-747">
              <div className="flex justify-between items-center" data-id="element-748">
                <label className="text-sm font-medium text-beige" data-id="element-749">
                  Password
                </label>
                <Link to="#" className="text-xs text-gold hover:text-gold-light transition-colors" data-id="element-750">
                  Forgot password?
                </Link>
              </div>
              <div className="relative" data-id="element-751">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" data-id="element-752" />
                <input type="password" className="w-full pl-12 pr-4 py-3 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white placeholder:text-white/20 transition-all" placeholder="••••••••" data-id="element-753" />
              </div>
            </div>

            <div className="flex items-center gap-2" data-id="element-754">
              <input type="checkbox" id="remember" className="rounded border-white/20 bg-midnight/50 text-gold focus:ring-gold focus:ring-offset-midnight" data-id="element-755" />
              <label htmlFor="remember" className="text-sm text-beige-muted" data-id="element-756">
                Remember me
              </label>
            </div>

            <Button type="submit" fullWidth variant="primary" className="mt-2" data-id="element-757">
              Sign In
            </Button>

            <div className="relative py-4" data-id="element-758">
              <div className="absolute inset-0 flex items-center" data-id="element-759">
                <div className="w-full border-t border-white/10" data-id="element-760"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-761">
                <span className="px-2 bg-midnight-elevated text-white/40" data-id="element-762">
                  Or continue with
                </span>
              </div>
            </div>

            <Button type="button" fullWidth variant="glass" className="bg-white/5" data-id="element-763">
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-764">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-765" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-766" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-767" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-768" />
              </svg>
              Google
            </Button>
          </form>

          <p className="text-center text-sm text-beige-muted mt-8" data-id="element-769">
            Don't have an account?{' '}
            <Link to="/contact" className="text-gold hover:text-white transition-colors" data-id="element-770">
              Create one &rarr;
            </Link>
          </p>
        </motion.div>
      </div>
    </div>;
}